export const CONCIERGE_TREATMENT_KEY = "redo.concierge_treatment";

export const EXPANDED_WARRANTY_TREATMENT_KEY =
  "redo.expanded_warranty_treatment";
export const RESCUE_PANEL_TREATMENT_KEY = "rrp_treatment_id";
export const RESCUE_PANEL_CTA_CLICKED_KEY = "rrp_cta_clicked";
export const PRICING_TEST_TREATMENT_KEY = "redo.pricing_test_treatment";

export const SESSION_IDS_CART_ATTRIBUTE_KEY = "redo.sessionIds";
export const CONCIERGE_ATTRIBUTION_CART_ATTRIBUTE_KEY =
  "redo.conciergeAssisted";
export const ANONYMOUS_ID_CART_ATTRIBUTE_KEY = "customer_event_id";
export const ANONYMOUS_SHOPIFY_SESSION_ID_CART_ATTRIBUTE_KEY =
  "checkout_session_id";
